// source: endpoint-api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.endpoint_api.AggregatedEndpointAnalytics', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointCacheConfigurationRequest', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointCacheConfigurationResponse', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointProviderModelRequest', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointProviderModelResponse', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointRequest', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointResponse', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointRetryConfigurationRequest', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointRetryConfigurationResponse', null, global);
goog.exportSymbol('proto.endpoint_api.CreateEndpointTagRequest', null, global);
goog.exportSymbol('proto.endpoint_api.Endpoint', null, global);
goog.exportSymbol('proto.endpoint_api.EndpointAttribute', null, global);
goog.exportSymbol('proto.endpoint_api.EndpointCacheConfiguration', null, global);
goog.exportSymbol('proto.endpoint_api.EndpointLog', null, global);
goog.exportSymbol('proto.endpoint_api.EndpointProviderModel', null, global);
goog.exportSymbol('proto.endpoint_api.EndpointProviderModelAttribute', null, global);
goog.exportSymbol('proto.endpoint_api.EndpointRetryConfiguration', null, global);
goog.exportSymbol('proto.endpoint_api.ForkEndpointRequest', null, global);
goog.exportSymbol('proto.endpoint_api.GetAllEndpointLogRequest', null, global);
goog.exportSymbol('proto.endpoint_api.GetAllEndpointLogResponse', null, global);
goog.exportSymbol('proto.endpoint_api.GetAllEndpointProviderModelRequest', null, global);
goog.exportSymbol('proto.endpoint_api.GetAllEndpointProviderModelResponse', null, global);
goog.exportSymbol('proto.endpoint_api.GetAllEndpointRequest', null, global);
goog.exportSymbol('proto.endpoint_api.GetAllEndpointResponse', null, global);
goog.exportSymbol('proto.endpoint_api.GetEndpointLogRequest', null, global);
goog.exportSymbol('proto.endpoint_api.GetEndpointLogResponse', null, global);
goog.exportSymbol('proto.endpoint_api.GetEndpointRequest', null, global);
goog.exportSymbol('proto.endpoint_api.GetEndpointResponse', null, global);
goog.exportSymbol('proto.endpoint_api.UpdateEndpointDetailRequest', null, global);
goog.exportSymbol('proto.endpoint_api.UpdateEndpointVersionRequest', null, global);
goog.exportSymbol('proto.endpoint_api.UpdateEndpointVersionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.EndpointAttribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.EndpointAttribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.EndpointAttribute.displayName = 'proto.endpoint_api.EndpointAttribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.EndpointProviderModelAttribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.EndpointProviderModelAttribute.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.EndpointProviderModelAttribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.EndpointProviderModelAttribute.displayName = 'proto.endpoint_api.EndpointProviderModelAttribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.CreateEndpointRequest.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointRequest.displayName = 'proto.endpoint_api.CreateEndpointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointResponse.displayName = 'proto.endpoint_api.CreateEndpointResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.EndpointProviderModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.EndpointProviderModel.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.EndpointProviderModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.EndpointProviderModel.displayName = 'proto.endpoint_api.EndpointProviderModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.AggregatedEndpointAnalytics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.AggregatedEndpointAnalytics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.AggregatedEndpointAnalytics.displayName = 'proto.endpoint_api.AggregatedEndpointAnalytics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.Endpoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.Endpoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.Endpoint.displayName = 'proto.endpoint_api.Endpoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointProviderModelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointProviderModelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointProviderModelRequest.displayName = 'proto.endpoint_api.CreateEndpointProviderModelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointProviderModelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointProviderModelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointProviderModelResponse.displayName = 'proto.endpoint_api.CreateEndpointProviderModelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetEndpointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.GetEndpointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetEndpointRequest.displayName = 'proto.endpoint_api.GetEndpointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetEndpointResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.GetEndpointResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetEndpointResponse.displayName = 'proto.endpoint_api.GetEndpointResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetAllEndpointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.GetAllEndpointRequest.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.GetAllEndpointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetAllEndpointRequest.displayName = 'proto.endpoint_api.GetAllEndpointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetAllEndpointResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.GetAllEndpointResponse.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.GetAllEndpointResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetAllEndpointResponse.displayName = 'proto.endpoint_api.GetAllEndpointResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.GetAllEndpointProviderModelRequest.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.GetAllEndpointProviderModelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetAllEndpointProviderModelRequest.displayName = 'proto.endpoint_api.GetAllEndpointProviderModelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.GetAllEndpointProviderModelResponse.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.GetAllEndpointProviderModelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetAllEndpointProviderModelResponse.displayName = 'proto.endpoint_api.GetAllEndpointProviderModelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.UpdateEndpointVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.UpdateEndpointVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.UpdateEndpointVersionRequest.displayName = 'proto.endpoint_api.UpdateEndpointVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.UpdateEndpointVersionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.UpdateEndpointVersionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.UpdateEndpointVersionResponse.displayName = 'proto.endpoint_api.UpdateEndpointVersionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.EndpointRetryConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.EndpointRetryConfiguration.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.EndpointRetryConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.EndpointRetryConfiguration.displayName = 'proto.endpoint_api.EndpointRetryConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.EndpointCacheConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.EndpointCacheConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.EndpointCacheConfiguration.displayName = 'proto.endpoint_api.EndpointCacheConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointRetryConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointRetryConfigurationRequest.displayName = 'proto.endpoint_api.CreateEndpointRetryConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointRetryConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointRetryConfigurationResponse.displayName = 'proto.endpoint_api.CreateEndpointRetryConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointCacheConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointCacheConfigurationRequest.displayName = 'proto.endpoint_api.CreateEndpointCacheConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointCacheConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointCacheConfigurationResponse.displayName = 'proto.endpoint_api.CreateEndpointCacheConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.CreateEndpointTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.CreateEndpointTagRequest.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.CreateEndpointTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.CreateEndpointTagRequest.displayName = 'proto.endpoint_api.CreateEndpointTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.ForkEndpointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.ForkEndpointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.ForkEndpointRequest.displayName = 'proto.endpoint_api.ForkEndpointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.UpdateEndpointDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.UpdateEndpointDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.UpdateEndpointDetailRequest.displayName = 'proto.endpoint_api.UpdateEndpointDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.EndpointLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.EndpointLog.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.EndpointLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.EndpointLog.displayName = 'proto.endpoint_api.EndpointLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetAllEndpointLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.GetAllEndpointLogRequest.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.GetAllEndpointLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetAllEndpointLogRequest.displayName = 'proto.endpoint_api.GetAllEndpointLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetAllEndpointLogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.endpoint_api.GetAllEndpointLogResponse.repeatedFields_, null);
};
goog.inherits(proto.endpoint_api.GetAllEndpointLogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetAllEndpointLogResponse.displayName = 'proto.endpoint_api.GetAllEndpointLogResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetEndpointLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.GetEndpointLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetEndpointLogRequest.displayName = 'proto.endpoint_api.GetEndpointLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.endpoint_api.GetEndpointLogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.endpoint_api.GetEndpointLogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.endpoint_api.GetEndpointLogResponse.displayName = 'proto.endpoint_api.GetEndpointLogResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.EndpointAttribute.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.EndpointAttribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.EndpointAttribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointAttribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    source: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sourceidentifier: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    visibility: jspb.Message.getFieldWithDefault(msg, 4, ""),
    language: jspb.Message.getFieldWithDefault(msg, 6, ""),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    description: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.EndpointAttribute}
 */
proto.endpoint_api.EndpointAttribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.EndpointAttribute;
  return proto.endpoint_api.EndpointAttribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.EndpointAttribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.EndpointAttribute}
 */
proto.endpoint_api.EndpointAttribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setSourceidentifier(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisibility(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.EndpointAttribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.EndpointAttribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.EndpointAttribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointAttribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceidentifier();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getVisibility();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string source = 1;
 * @return {string}
 */
proto.endpoint_api.EndpointAttribute.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointAttribute} returns this
 */
proto.endpoint_api.EndpointAttribute.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sourceIdentifier = 2;
 * @return {string}
 */
proto.endpoint_api.EndpointAttribute.prototype.getSourceidentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointAttribute} returns this
 */
proto.endpoint_api.EndpointAttribute.prototype.setSourceidentifier = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string visibility = 4;
 * @return {string}
 */
proto.endpoint_api.EndpointAttribute.prototype.getVisibility = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointAttribute} returns this
 */
proto.endpoint_api.EndpointAttribute.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string language = 6;
 * @return {string}
 */
proto.endpoint_api.EndpointAttribute.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointAttribute} returns this
 */
proto.endpoint_api.EndpointAttribute.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.endpoint_api.EndpointAttribute.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointAttribute} returns this
 */
proto.endpoint_api.EndpointAttribute.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string description = 8;
 * @return {string}
 */
proto.endpoint_api.EndpointAttribute.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointAttribute} returns this
 */
proto.endpoint_api.EndpointAttribute.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.EndpointProviderModelAttribute.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.EndpointProviderModelAttribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.EndpointProviderModelAttribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointProviderModelAttribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chatcompleteprompt: (f = msg.getChatcompleteprompt()) && common_pb.TextChatCompletePrompt.toObject(includeInstance, f),
    modelprovidername: jspb.Message.getFieldWithDefault(msg, 7, ""),
    endpointmodeloptionsList: jspb.Message.toObjectList(msg.getEndpointmodeloptionsList(),
    common_pb.Metadata.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute}
 */
proto.endpoint_api.EndpointProviderModelAttribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.EndpointProviderModelAttribute;
  return proto.endpoint_api.EndpointProviderModelAttribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.EndpointProviderModelAttribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute}
 */
proto.endpoint_api.EndpointProviderModelAttribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = new common_pb.TextChatCompletePrompt;
      reader.readMessage(value,common_pb.TextChatCompletePrompt.deserializeBinaryFromReader);
      msg.setChatcompleteprompt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelprovidername(value);
      break;
    case 8:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addEndpointmodeloptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.EndpointProviderModelAttribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.EndpointProviderModelAttribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointProviderModelAttribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChatcompleteprompt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.TextChatCompletePrompt.serializeBinaryToWriter
    );
  }
  f = message.getModelprovidername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEndpointmodeloptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute} returns this
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TextChatCompletePrompt chatCompletePrompt = 2;
 * @return {?proto.TextChatCompletePrompt}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.getChatcompleteprompt = function() {
  return /** @type{?proto.TextChatCompletePrompt} */ (
    jspb.Message.getWrapperField(this, common_pb.TextChatCompletePrompt, 2));
};


/**
 * @param {?proto.TextChatCompletePrompt|undefined} value
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute} returns this
*/
proto.endpoint_api.EndpointProviderModelAttribute.prototype.setChatcompleteprompt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute} returns this
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.clearChatcompleteprompt = function() {
  return this.setChatcompleteprompt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.hasChatcompleteprompt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string modelProviderName = 7;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.getModelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute} returns this
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.setModelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Metadata endpointModelOptions = 8;
 * @return {!Array<!proto.Metadata>}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.getEndpointmodeloptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 8));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute} returns this
*/
proto.endpoint_api.EndpointProviderModelAttribute.prototype.setEndpointmodeloptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.addEndpointmodeloptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.EndpointProviderModelAttribute} returns this
 */
proto.endpoint_api.EndpointProviderModelAttribute.prototype.clearEndpointmodeloptionsList = function() {
  return this.setEndpointmodeloptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.CreateEndpointRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointprovidermodelattribute: (f = msg.getEndpointprovidermodelattribute()) && proto.endpoint_api.EndpointProviderModelAttribute.toObject(includeInstance, f),
    endpointattribute: (f = msg.getEndpointattribute()) && proto.endpoint_api.EndpointAttribute.toObject(includeInstance, f),
    retryconfiguration: (f = msg.getRetryconfiguration()) && proto.endpoint_api.EndpointRetryConfiguration.toObject(includeInstance, f),
    cacheconfiguration: (f = msg.getCacheconfiguration()) && proto.endpoint_api.EndpointCacheConfiguration.toObject(includeInstance, f),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointRequest}
 */
proto.endpoint_api.CreateEndpointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointRequest;
  return proto.endpoint_api.CreateEndpointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointRequest}
 */
proto.endpoint_api.CreateEndpointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.endpoint_api.EndpointProviderModelAttribute;
      reader.readMessage(value,proto.endpoint_api.EndpointProviderModelAttribute.deserializeBinaryFromReader);
      msg.setEndpointprovidermodelattribute(value);
      break;
    case 2:
      var value = new proto.endpoint_api.EndpointAttribute;
      reader.readMessage(value,proto.endpoint_api.EndpointAttribute.deserializeBinaryFromReader);
      msg.setEndpointattribute(value);
      break;
    case 3:
      var value = new proto.endpoint_api.EndpointRetryConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointRetryConfiguration.deserializeBinaryFromReader);
      msg.setRetryconfiguration(value);
      break;
    case 4:
      var value = new proto.endpoint_api.EndpointCacheConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointCacheConfiguration.deserializeBinaryFromReader);
      msg.setCacheconfiguration(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointprovidermodelattribute();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.endpoint_api.EndpointProviderModelAttribute.serializeBinaryToWriter
    );
  }
  f = message.getEndpointattribute();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.endpoint_api.EndpointAttribute.serializeBinaryToWriter
    );
  }
  f = message.getRetryconfiguration();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.EndpointRetryConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getCacheconfiguration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.endpoint_api.EndpointCacheConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional EndpointProviderModelAttribute endpointProviderModelAttribute = 1;
 * @return {?proto.endpoint_api.EndpointProviderModelAttribute}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.getEndpointprovidermodelattribute = function() {
  return /** @type{?proto.endpoint_api.EndpointProviderModelAttribute} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointProviderModelAttribute, 1));
};


/**
 * @param {?proto.endpoint_api.EndpointProviderModelAttribute|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
*/
proto.endpoint_api.CreateEndpointRequest.prototype.setEndpointprovidermodelattribute = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
 */
proto.endpoint_api.CreateEndpointRequest.prototype.clearEndpointprovidermodelattribute = function() {
  return this.setEndpointprovidermodelattribute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.hasEndpointprovidermodelattribute = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EndpointAttribute endpointAttribute = 2;
 * @return {?proto.endpoint_api.EndpointAttribute}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.getEndpointattribute = function() {
  return /** @type{?proto.endpoint_api.EndpointAttribute} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointAttribute, 2));
};


/**
 * @param {?proto.endpoint_api.EndpointAttribute|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
*/
proto.endpoint_api.CreateEndpointRequest.prototype.setEndpointattribute = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
 */
proto.endpoint_api.CreateEndpointRequest.prototype.clearEndpointattribute = function() {
  return this.setEndpointattribute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.hasEndpointattribute = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EndpointRetryConfiguration retryConfiguration = 3;
 * @return {?proto.endpoint_api.EndpointRetryConfiguration}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.getRetryconfiguration = function() {
  return /** @type{?proto.endpoint_api.EndpointRetryConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointRetryConfiguration, 3));
};


/**
 * @param {?proto.endpoint_api.EndpointRetryConfiguration|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
*/
proto.endpoint_api.CreateEndpointRequest.prototype.setRetryconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
 */
proto.endpoint_api.CreateEndpointRequest.prototype.clearRetryconfiguration = function() {
  return this.setRetryconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.hasRetryconfiguration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EndpointCacheConfiguration cacheConfiguration = 4;
 * @return {?proto.endpoint_api.EndpointCacheConfiguration}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.getCacheconfiguration = function() {
  return /** @type{?proto.endpoint_api.EndpointCacheConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointCacheConfiguration, 4));
};


/**
 * @param {?proto.endpoint_api.EndpointCacheConfiguration|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
*/
proto.endpoint_api.CreateEndpointRequest.prototype.setCacheconfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
 */
proto.endpoint_api.CreateEndpointRequest.prototype.clearCacheconfiguration = function() {
  return this.setCacheconfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.hasCacheconfiguration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string tags = 5;
 * @return {!Array<string>}
 */
proto.endpoint_api.CreateEndpointRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
 */
proto.endpoint_api.CreateEndpointRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
 */
proto.endpoint_api.CreateEndpointRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.CreateEndpointRequest} returns this
 */
proto.endpoint_api.CreateEndpointRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.endpoint_api.Endpoint.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointResponse}
 */
proto.endpoint_api.CreateEndpointResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointResponse;
  return proto.endpoint_api.CreateEndpointResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointResponse}
 */
proto.endpoint_api.CreateEndpointResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.Endpoint;
      reader.readMessage(value,proto.endpoint_api.Endpoint.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.Endpoint.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.CreateEndpointResponse} returns this
 */
proto.endpoint_api.CreateEndpointResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.CreateEndpointResponse} returns this
 */
proto.endpoint_api.CreateEndpointResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Endpoint data = 3;
 * @return {?proto.endpoint_api.Endpoint}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.Endpoint} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.Endpoint, 3));
};


/**
 * @param {?proto.endpoint_api.Endpoint|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointResponse} returns this
*/
proto.endpoint_api.CreateEndpointResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointResponse} returns this
 */
proto.endpoint_api.CreateEndpointResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointResponse} returns this
*/
proto.endpoint_api.CreateEndpointResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointResponse} returns this
 */
proto.endpoint_api.CreateEndpointResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.EndpointProviderModel.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.EndpointProviderModel.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.EndpointProviderModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.EndpointProviderModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointProviderModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    chatcompleteprompt: (f = msg.getChatcompleteprompt()) && common_pb.TextChatCompletePrompt.toObject(includeInstance, f),
    modelprovidername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    endpointmodeloptionsList: jspb.Message.toObjectList(msg.getEndpointmodeloptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    createdby: jspb.Message.getFieldWithDefault(msg, 13, "0"),
    createduser: (f = msg.getCreateduser()) && common_pb.User.toObject(includeInstance, f),
    updatedby: jspb.Message.getFieldWithDefault(msg, 15, "0"),
    updateduser: (f = msg.getUpdateduser()) && common_pb.User.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endpointid: jspb.Message.getFieldWithDefault(msg, 19, "0"),
    description: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.EndpointProviderModel}
 */
proto.endpoint_api.EndpointProviderModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.EndpointProviderModel;
  return proto.endpoint_api.EndpointProviderModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.EndpointProviderModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.EndpointProviderModel}
 */
proto.endpoint_api.EndpointProviderModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = new common_pb.TextChatCompletePrompt;
      reader.readMessage(value,common_pb.TextChatCompletePrompt.deserializeBinaryFromReader);
      msg.setChatcompleteprompt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelprovidername(value);
      break;
    case 5:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addEndpointmodeloptions(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCreatedby(value);
      break;
    case 14:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setCreateduser(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUpdatedby(value);
      break;
    case 16:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setUpdateduser(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.EndpointProviderModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.EndpointProviderModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.EndpointProviderModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointProviderModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getChatcompleteprompt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.TextChatCompletePrompt.serializeBinaryToWriter
    );
  }
  f = message.getModelprovidername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEndpointmodeloptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      13,
      f
    );
  }
  f = message.getCreateduser();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      15,
      f
    );
  }
  f = message.getUpdateduser();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      19,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional TextChatCompletePrompt chatCompletePrompt = 2;
 * @return {?proto.TextChatCompletePrompt}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getChatcompleteprompt = function() {
  return /** @type{?proto.TextChatCompletePrompt} */ (
    jspb.Message.getWrapperField(this, common_pb.TextChatCompletePrompt, 2));
};


/**
 * @param {?proto.TextChatCompletePrompt|undefined} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
*/
proto.endpoint_api.EndpointProviderModel.prototype.setChatcompleteprompt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.clearChatcompleteprompt = function() {
  return this.setChatcompleteprompt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointProviderModel.prototype.hasChatcompleteprompt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string modelProviderName = 4;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getModelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.setModelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated Metadata endpointModelOptions = 5;
 * @return {!Array<!proto.Metadata>}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getEndpointmodeloptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 5));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
*/
proto.endpoint_api.EndpointProviderModel.prototype.setEndpointmodeloptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.endpoint_api.EndpointProviderModel.prototype.addEndpointmodeloptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.clearEndpointmodeloptionsList = function() {
  return this.setEndpointmodeloptionsList([]);
};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint64 createdBy = 13;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getCreatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.setCreatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 13, value);
};


/**
 * optional User createdUser = 14;
 * @return {?proto.User}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getCreateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 14));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
*/
proto.endpoint_api.EndpointProviderModel.prototype.setCreateduser = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.clearCreateduser = function() {
  return this.setCreateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointProviderModel.prototype.hasCreateduser = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional uint64 updatedBy = 15;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getUpdatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.setUpdatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 15, value);
};


/**
 * optional User updatedUser = 16;
 * @return {?proto.User}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getUpdateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 16));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
*/
proto.endpoint_api.EndpointProviderModel.prototype.setUpdateduser = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.clearUpdateduser = function() {
  return this.setUpdateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointProviderModel.prototype.hasUpdateduser = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
*/
proto.endpoint_api.EndpointProviderModel.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointProviderModel.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
*/
proto.endpoint_api.EndpointProviderModel.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointProviderModel.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional uint64 endpointId = 19;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 19, value);
};


/**
 * optional string description = 20;
 * @return {string}
 */
proto.endpoint_api.EndpointProviderModel.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointProviderModel} returns this
 */
proto.endpoint_api.EndpointProviderModel.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.AggregatedEndpointAnalytics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.AggregatedEndpointAnalytics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.AggregatedEndpointAnalytics.toObject = function(includeInstance, msg) {
  var f, obj = {
    count: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    totalinputcost: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    totaloutputcost: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    totaltoken: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    successcount: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    errorcount: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    p50latency: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    p99latency: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    lastactivity: (f = msg.getLastactivity()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.AggregatedEndpointAnalytics;
  return proto.endpoint_api.AggregatedEndpointAnalytics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.AggregatedEndpointAnalytics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalinputcost(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotaloutputcost(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTotaltoken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setSuccesscount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setErrorcount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setP50latency(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setP99latency(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastactivity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.AggregatedEndpointAnalytics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.AggregatedEndpointAnalytics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.AggregatedEndpointAnalytics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getTotalinputcost();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getTotaloutputcost();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getTotaltoken();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getSuccesscount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getErrorcount();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getP50latency();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getP99latency();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getLastactivity();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 count = 1;
 * @return {string}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getCount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setCount = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional float totalInputCost = 2;
 * @return {number}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getTotalinputcost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setTotalinputcost = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float totalOutputCost = 3;
 * @return {number}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getTotaloutputcost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setTotaloutputcost = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional uint64 totalToken = 4;
 * @return {string}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getTotaltoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setTotaltoken = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional uint64 successCount = 5;
 * @return {string}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getSuccesscount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setSuccesscount = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 errorCount = 6;
 * @return {string}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getErrorcount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setErrorcount = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional float p50Latency = 7;
 * @return {number}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getP50latency = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setP50latency = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional float p99Latency = 8;
 * @return {number}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getP99latency = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setP99latency = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp lastActivity = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.getLastactivity = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
*/
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.setLastactivity = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.AggregatedEndpointAnalytics} returns this
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.clearLastactivity = function() {
  return this.setLastactivity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.AggregatedEndpointAnalytics.prototype.hasLastactivity = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.Endpoint.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.Endpoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.Endpoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.Endpoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    visibility: jspb.Message.getFieldWithDefault(msg, 3, ""),
    source: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sourceidentifier: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    projectid: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    organizationid: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    endpointprovidermodelid: jspb.Message.getFieldWithDefault(msg, 9, "0"),
    endpointprovidermodel: (f = msg.getEndpointprovidermodel()) && proto.endpoint_api.EndpointProviderModel.toObject(includeInstance, f),
    endpointanalytics: (f = msg.getEndpointanalytics()) && proto.endpoint_api.AggregatedEndpointAnalytics.toObject(includeInstance, f),
    endpointretry: (f = msg.getEndpointretry()) && proto.endpoint_api.EndpointRetryConfiguration.toObject(includeInstance, f),
    endpointcaching: (f = msg.getEndpointcaching()) && proto.endpoint_api.EndpointCacheConfiguration.toObject(includeInstance, f),
    endpointtag: (f = msg.getEndpointtag()) && common_pb.Tag.toObject(includeInstance, f),
    language: jspb.Message.getFieldWithDefault(msg, 16, ""),
    organization: (f = msg.getOrganization()) && common_pb.Organization.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 18, ""),
    description: jspb.Message.getFieldWithDefault(msg, 19, ""),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdby: jspb.Message.getFieldWithDefault(msg, 22, "0"),
    createduser: (f = msg.getCreateduser()) && common_pb.User.toObject(includeInstance, f),
    updatedby: jspb.Message.getFieldWithDefault(msg, 24, "0"),
    updateduser: (f = msg.getUpdateduser()) && common_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.Endpoint}
 */
proto.endpoint_api.Endpoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.Endpoint;
  return proto.endpoint_api.Endpoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.Endpoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.Endpoint}
 */
proto.endpoint_api.Endpoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisibility(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setSourceidentifier(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrganizationid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointprovidermodelid(value);
      break;
    case 10:
      var value = new proto.endpoint_api.EndpointProviderModel;
      reader.readMessage(value,proto.endpoint_api.EndpointProviderModel.deserializeBinaryFromReader);
      msg.setEndpointprovidermodel(value);
      break;
    case 11:
      var value = new proto.endpoint_api.AggregatedEndpointAnalytics;
      reader.readMessage(value,proto.endpoint_api.AggregatedEndpointAnalytics.deserializeBinaryFromReader);
      msg.setEndpointanalytics(value);
      break;
    case 12:
      var value = new proto.endpoint_api.EndpointRetryConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointRetryConfiguration.deserializeBinaryFromReader);
      msg.setEndpointretry(value);
      break;
    case 13:
      var value = new proto.endpoint_api.EndpointCacheConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointCacheConfiguration.deserializeBinaryFromReader);
      msg.setEndpointcaching(value);
      break;
    case 14:
      var value = new common_pb.Tag;
      reader.readMessage(value,common_pb.Tag.deserializeBinaryFromReader);
      msg.setEndpointtag(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 17:
      var value = new common_pb.Organization;
      reader.readMessage(value,common_pb.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCreatedby(value);
      break;
    case 23:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setCreateduser(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUpdatedby(value);
      break;
    case 25:
      var value = new common_pb.User;
      reader.readMessage(value,common_pb.User.deserializeBinaryFromReader);
      msg.setUpdateduser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.Endpoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.Endpoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.Endpoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.Endpoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVisibility();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSourceidentifier();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      7,
      f
    );
  }
  f = message.getOrganizationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      8,
      f
    );
  }
  f = message.getEndpointprovidermodelid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      9,
      f
    );
  }
  f = message.getEndpointprovidermodel();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.endpoint_api.EndpointProviderModel.serializeBinaryToWriter
    );
  }
  f = message.getEndpointanalytics();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.endpoint_api.AggregatedEndpointAnalytics.serializeBinaryToWriter
    );
  }
  f = message.getEndpointretry();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.endpoint_api.EndpointRetryConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getEndpointcaching();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.endpoint_api.EndpointCacheConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getEndpointtag();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.Tag.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.Organization.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      22,
      f
    );
  }
  f = message.getCreateduser();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      24,
      f
    );
  }
  f = message.getUpdateduser();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      common_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string visibility = 3;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getVisibility = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string source = 4;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 sourceIdentifier = 5;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getSourceidentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setSourceidentifier = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 projectId = 7;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional uint64 organizationId = 8;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional uint64 endpointProviderModelId = 9;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getEndpointprovidermodelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setEndpointprovidermodelid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 9, value);
};


/**
 * optional EndpointProviderModel endpointProviderModel = 10;
 * @return {?proto.endpoint_api.EndpointProviderModel}
 */
proto.endpoint_api.Endpoint.prototype.getEndpointprovidermodel = function() {
  return /** @type{?proto.endpoint_api.EndpointProviderModel} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointProviderModel, 10));
};


/**
 * @param {?proto.endpoint_api.EndpointProviderModel|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setEndpointprovidermodel = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearEndpointprovidermodel = function() {
  return this.setEndpointprovidermodel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasEndpointprovidermodel = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional AggregatedEndpointAnalytics endpointAnalytics = 11;
 * @return {?proto.endpoint_api.AggregatedEndpointAnalytics}
 */
proto.endpoint_api.Endpoint.prototype.getEndpointanalytics = function() {
  return /** @type{?proto.endpoint_api.AggregatedEndpointAnalytics} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.AggregatedEndpointAnalytics, 11));
};


/**
 * @param {?proto.endpoint_api.AggregatedEndpointAnalytics|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setEndpointanalytics = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearEndpointanalytics = function() {
  return this.setEndpointanalytics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasEndpointanalytics = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional EndpointRetryConfiguration endpointRetry = 12;
 * @return {?proto.endpoint_api.EndpointRetryConfiguration}
 */
proto.endpoint_api.Endpoint.prototype.getEndpointretry = function() {
  return /** @type{?proto.endpoint_api.EndpointRetryConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointRetryConfiguration, 12));
};


/**
 * @param {?proto.endpoint_api.EndpointRetryConfiguration|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setEndpointretry = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearEndpointretry = function() {
  return this.setEndpointretry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasEndpointretry = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional EndpointCacheConfiguration endpointCaching = 13;
 * @return {?proto.endpoint_api.EndpointCacheConfiguration}
 */
proto.endpoint_api.Endpoint.prototype.getEndpointcaching = function() {
  return /** @type{?proto.endpoint_api.EndpointCacheConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointCacheConfiguration, 13));
};


/**
 * @param {?proto.endpoint_api.EndpointCacheConfiguration|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setEndpointcaching = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearEndpointcaching = function() {
  return this.setEndpointcaching(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasEndpointcaching = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Tag endpointTag = 14;
 * @return {?proto.Tag}
 */
proto.endpoint_api.Endpoint.prototype.getEndpointtag = function() {
  return /** @type{?proto.Tag} */ (
    jspb.Message.getWrapperField(this, common_pb.Tag, 14));
};


/**
 * @param {?proto.Tag|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setEndpointtag = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearEndpointtag = function() {
  return this.setEndpointtag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasEndpointtag = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string language = 16;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional Organization organization = 17;
 * @return {?proto.Organization}
 */
proto.endpoint_api.Endpoint.prototype.getOrganization = function() {
  return /** @type{?proto.Organization} */ (
    jspb.Message.getWrapperField(this, common_pb.Organization, 17));
};


/**
 * @param {?proto.Organization|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string name = 18;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string description = 19;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.endpoint_api.Endpoint.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.endpoint_api.Endpoint.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional uint64 createdBy = 22;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getCreatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setCreatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 22, value);
};


/**
 * optional User createdUser = 23;
 * @return {?proto.User}
 */
proto.endpoint_api.Endpoint.prototype.getCreateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 23));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setCreateduser = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearCreateduser = function() {
  return this.setCreateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasCreateduser = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional uint64 updatedBy = 24;
 * @return {string}
 */
proto.endpoint_api.Endpoint.prototype.getUpdatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.setUpdatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 24, value);
};


/**
 * optional User updatedUser = 25;
 * @return {?proto.User}
 */
proto.endpoint_api.Endpoint.prototype.getUpdateduser = function() {
  return /** @type{?proto.User} */ (
    jspb.Message.getWrapperField(this, common_pb.User, 25));
};


/**
 * @param {?proto.User|undefined} value
 * @return {!proto.endpoint_api.Endpoint} returns this
*/
proto.endpoint_api.Endpoint.prototype.setUpdateduser = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.Endpoint} returns this
 */
proto.endpoint_api.Endpoint.prototype.clearUpdateduser = function() {
  return this.setUpdateduser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.Endpoint.prototype.hasUpdateduser = function() {
  return jspb.Message.getField(this, 25) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointProviderModelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointProviderModelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    endpointprovidermodelattribute: (f = msg.getEndpointprovidermodelattribute()) && proto.endpoint_api.EndpointProviderModelAttribute.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointProviderModelRequest}
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointProviderModelRequest;
  return proto.endpoint_api.CreateEndpointProviderModelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointProviderModelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointProviderModelRequest}
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 2:
      var value = new proto.endpoint_api.EndpointProviderModelAttribute;
      reader.readMessage(value,proto.endpoint_api.EndpointProviderModelAttribute.deserializeBinaryFromReader);
      msg.setEndpointprovidermodelattribute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointProviderModelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointProviderModelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getEndpointprovidermodelattribute();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.endpoint_api.EndpointProviderModelAttribute.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.CreateEndpointProviderModelRequest} returns this
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional EndpointProviderModelAttribute endpointProviderModelAttribute = 2;
 * @return {?proto.endpoint_api.EndpointProviderModelAttribute}
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.getEndpointprovidermodelattribute = function() {
  return /** @type{?proto.endpoint_api.EndpointProviderModelAttribute} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointProviderModelAttribute, 2));
};


/**
 * @param {?proto.endpoint_api.EndpointProviderModelAttribute|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointProviderModelRequest} returns this
*/
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.setEndpointprovidermodelattribute = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointProviderModelRequest} returns this
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.clearEndpointprovidermodelattribute = function() {
  return this.setEndpointprovidermodelattribute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointProviderModelRequest.prototype.hasEndpointprovidermodelattribute = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointProviderModelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointProviderModelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.endpoint_api.EndpointProviderModel.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointProviderModelResponse;
  return proto.endpoint_api.CreateEndpointProviderModelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointProviderModelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.EndpointProviderModel;
      reader.readMessage(value,proto.endpoint_api.EndpointProviderModel.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointProviderModelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointProviderModelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.EndpointProviderModel.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional EndpointProviderModel data = 3;
 * @return {?proto.endpoint_api.EndpointProviderModel}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.EndpointProviderModel} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointProviderModel, 3));
};


/**
 * @param {?proto.endpoint_api.EndpointProviderModel|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse} returns this
*/
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse} returns this
*/
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointProviderModelResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetEndpointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetEndpointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetEndpointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    endpointprovidermodelid: jspb.Message.getFieldWithDefault(msg, 4, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetEndpointRequest}
 */
proto.endpoint_api.GetEndpointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetEndpointRequest;
  return proto.endpoint_api.GetEndpointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetEndpointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetEndpointRequest}
 */
proto.endpoint_api.GetEndpointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointprovidermodelid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetEndpointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetEndpointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetEndpointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64String(
      4,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.endpoint_api.GetEndpointRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.GetEndpointRequest} returns this
 */
proto.endpoint_api.GetEndpointRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 endpointProviderModelId = 4;
 * @return {string}
 */
proto.endpoint_api.GetEndpointRequest.prototype.getEndpointprovidermodelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.GetEndpointRequest} returns this
 */
proto.endpoint_api.GetEndpointRequest.prototype.setEndpointprovidermodelid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.endpoint_api.GetEndpointRequest} returns this
 */
proto.endpoint_api.GetEndpointRequest.prototype.clearEndpointprovidermodelid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetEndpointRequest.prototype.hasEndpointprovidermodelid = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetEndpointResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetEndpointResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetEndpointResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.endpoint_api.Endpoint.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetEndpointResponse}
 */
proto.endpoint_api.GetEndpointResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetEndpointResponse;
  return proto.endpoint_api.GetEndpointResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetEndpointResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetEndpointResponse}
 */
proto.endpoint_api.GetEndpointResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.Endpoint;
      reader.readMessage(value,proto.endpoint_api.Endpoint.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetEndpointResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetEndpointResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetEndpointResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.Endpoint.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.GetEndpointResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.GetEndpointResponse} returns this
 */
proto.endpoint_api.GetEndpointResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.GetEndpointResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.GetEndpointResponse} returns this
 */
proto.endpoint_api.GetEndpointResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Endpoint data = 3;
 * @return {?proto.endpoint_api.Endpoint}
 */
proto.endpoint_api.GetEndpointResponse.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.Endpoint} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.Endpoint, 3));
};


/**
 * @param {?proto.endpoint_api.Endpoint|undefined} value
 * @return {!proto.endpoint_api.GetEndpointResponse} returns this
*/
proto.endpoint_api.GetEndpointResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetEndpointResponse} returns this
 */
proto.endpoint_api.GetEndpointResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetEndpointResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.GetEndpointResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.GetEndpointResponse} returns this
*/
proto.endpoint_api.GetEndpointResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetEndpointResponse} returns this
 */
proto.endpoint_api.GetEndpointResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetEndpointResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.GetAllEndpointRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetAllEndpointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetAllEndpointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetAllEndpointRequest}
 */
proto.endpoint_api.GetAllEndpointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetAllEndpointRequest;
  return proto.endpoint_api.GetAllEndpointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetAllEndpointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetAllEndpointRequest}
 */
proto.endpoint_api.GetAllEndpointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 2:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetAllEndpointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetAllEndpointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional Paginate paginate = 1;
 * @return {?proto.Paginate}
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 1));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointRequest} returns this
*/
proto.endpoint_api.GetAllEndpointRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointRequest} returns this
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Criteria criterias = 2;
 * @return {!Array<!proto.Criteria>}
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 2));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.endpoint_api.GetAllEndpointRequest} returns this
*/
proto.endpoint_api.GetAllEndpointRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.GetAllEndpointRequest} returns this
 */
proto.endpoint_api.GetAllEndpointRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.GetAllEndpointResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetAllEndpointResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetAllEndpointResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.endpoint_api.Endpoint.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetAllEndpointResponse}
 */
proto.endpoint_api.GetAllEndpointResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetAllEndpointResponse;
  return proto.endpoint_api.GetAllEndpointResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetAllEndpointResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetAllEndpointResponse}
 */
proto.endpoint_api.GetAllEndpointResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.Endpoint;
      reader.readMessage(value,proto.endpoint_api.Endpoint.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetAllEndpointResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetAllEndpointResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.endpoint_api.Endpoint.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Endpoint data = 3;
 * @return {!Array<!proto.endpoint_api.Endpoint>}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.endpoint_api.Endpoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.endpoint_api.Endpoint, 3));
};


/**
 * @param {!Array<!proto.endpoint_api.Endpoint>} value
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
*/
proto.endpoint_api.GetAllEndpointResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.endpoint_api.Endpoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.endpoint_api.Endpoint}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.endpoint_api.Endpoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
*/
proto.endpoint_api.GetAllEndpointResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
*/
proto.endpoint_api.GetAllEndpointResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointResponse} returns this
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetAllEndpointProviderModelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetAllEndpointProviderModelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance),
    endpointid: jspb.Message.getFieldWithDefault(msg, 5, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelRequest}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetAllEndpointProviderModelRequest;
  return proto.endpoint_api.GetAllEndpointProviderModelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetAllEndpointProviderModelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelRequest}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 2:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetAllEndpointProviderModelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetAllEndpointProviderModelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
};


/**
 * optional Paginate paginate = 1;
 * @return {?proto.Paginate}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 1));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelRequest} returns this
*/
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelRequest} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Criteria criterias = 2;
 * @return {!Array<!proto.Criteria>}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 2));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelRequest} returns this
*/
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelRequest} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};


/**
 * optional uint64 endpointId = 5;
 * @return {string}
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelRequest} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetAllEndpointProviderModelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetAllEndpointProviderModelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.endpoint_api.EndpointProviderModel.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetAllEndpointProviderModelResponse;
  return proto.endpoint_api.GetAllEndpointProviderModelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetAllEndpointProviderModelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.EndpointProviderModel;
      reader.readMessage(value,proto.endpoint_api.EndpointProviderModel.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetAllEndpointProviderModelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetAllEndpointProviderModelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.endpoint_api.EndpointProviderModel.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated EndpointProviderModel data = 3;
 * @return {!Array<!proto.endpoint_api.EndpointProviderModel>}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.endpoint_api.EndpointProviderModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.endpoint_api.EndpointProviderModel, 3));
};


/**
 * @param {!Array<!proto.endpoint_api.EndpointProviderModel>} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
*/
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.endpoint_api.EndpointProviderModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.endpoint_api.EndpointProviderModel}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.endpoint_api.EndpointProviderModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
*/
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
*/
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointProviderModelResponse} returns this
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointProviderModelResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.UpdateEndpointVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.UpdateEndpointVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.UpdateEndpointVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.UpdateEndpointVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    endpointprovidermodelid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.UpdateEndpointVersionRequest}
 */
proto.endpoint_api.UpdateEndpointVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.UpdateEndpointVersionRequest;
  return proto.endpoint_api.UpdateEndpointVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.UpdateEndpointVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.UpdateEndpointVersionRequest}
 */
proto.endpoint_api.UpdateEndpointVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointprovidermodelid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.UpdateEndpointVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.UpdateEndpointVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.UpdateEndpointVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.UpdateEndpointVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getEndpointprovidermodelid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.UpdateEndpointVersionRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.UpdateEndpointVersionRequest} returns this
 */
proto.endpoint_api.UpdateEndpointVersionRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 endpointProviderModelId = 2;
 * @return {string}
 */
proto.endpoint_api.UpdateEndpointVersionRequest.prototype.getEndpointprovidermodelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.UpdateEndpointVersionRequest} returns this
 */
proto.endpoint_api.UpdateEndpointVersionRequest.prototype.setEndpointprovidermodelid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.UpdateEndpointVersionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.UpdateEndpointVersionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.UpdateEndpointVersionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.endpoint_api.Endpoint.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.UpdateEndpointVersionResponse;
  return proto.endpoint_api.UpdateEndpointVersionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.UpdateEndpointVersionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.Endpoint;
      reader.readMessage(value,proto.endpoint_api.Endpoint.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.UpdateEndpointVersionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.UpdateEndpointVersionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.UpdateEndpointVersionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.Endpoint.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse} returns this
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse} returns this
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Endpoint data = 3;
 * @return {?proto.endpoint_api.Endpoint}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.Endpoint} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.Endpoint, 3));
};


/**
 * @param {?proto.endpoint_api.Endpoint|undefined} value
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse} returns this
*/
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse} returns this
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse} returns this
*/
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.UpdateEndpointVersionResponse} returns this
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.UpdateEndpointVersionResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.EndpointRetryConfiguration.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.EndpointRetryConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.EndpointRetryConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointRetryConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    retrytype: jspb.Message.getFieldWithDefault(msg, 2, ""),
    maxattempts: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    delayseconds: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    exponentialbackoff: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    retryablesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    createdby: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    updatedby: jspb.Message.getFieldWithDefault(msg, 9, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.EndpointRetryConfiguration}
 */
proto.endpoint_api.EndpointRetryConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.EndpointRetryConfiguration;
  return proto.endpoint_api.EndpointRetryConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.EndpointRetryConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.EndpointRetryConfiguration}
 */
proto.endpoint_api.EndpointRetryConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrytype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMaxattempts(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setDelayseconds(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExponentialbackoff(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addRetryables(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCreatedby(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUpdatedby(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.EndpointRetryConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.EndpointRetryConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointRetryConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRetrytype();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMaxattempts();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getDelayseconds();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getExponentialbackoff();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getRetryablesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getCreatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      8,
      f
    );
  }
  f = message.getUpdatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      9,
      f
    );
  }
};


/**
 * optional string retryType = 2;
 * @return {string}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.getRetrytype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.setRetrytype = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 maxAttempts = 3;
 * @return {string}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.getMaxattempts = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.setMaxattempts = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional uint64 delaySeconds = 4;
 * @return {string}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.getDelayseconds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.setDelayseconds = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional bool exponentialBackoff = 5;
 * @return {boolean}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.getExponentialbackoff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.setExponentialbackoff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string retryables = 6;
 * @return {!Array<string>}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.getRetryablesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.setRetryablesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.addRetryables = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.clearRetryablesList = function() {
  return this.setRetryablesList([]);
};


/**
 * optional uint64 createdBy = 8;
 * @return {string}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.getCreatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.setCreatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional uint64 updatedBy = 9;
 * @return {string}
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.getUpdatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointRetryConfiguration} returns this
 */
proto.endpoint_api.EndpointRetryConfiguration.prototype.setUpdatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.EndpointCacheConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.EndpointCacheConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointCacheConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    cachetype: jspb.Message.getFieldWithDefault(msg, 2, ""),
    expiryinterval: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    matchthreshold: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    createdby: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    updatedby: jspb.Message.getFieldWithDefault(msg, 6, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.EndpointCacheConfiguration}
 */
proto.endpoint_api.EndpointCacheConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.EndpointCacheConfiguration;
  return proto.endpoint_api.EndpointCacheConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.EndpointCacheConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.EndpointCacheConfiguration}
 */
proto.endpoint_api.EndpointCacheConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCachetype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setExpiryinterval(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMatchthreshold(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setCreatedby(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setUpdatedby(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.EndpointCacheConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.EndpointCacheConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointCacheConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCachetype();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExpiryinterval();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getMatchthreshold();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getCreatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getUpdatedby();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
};


/**
 * optional string cacheType = 2;
 * @return {string}
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.getCachetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointCacheConfiguration} returns this
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.setCachetype = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 expiryInterval = 3;
 * @return {string}
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.getExpiryinterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointCacheConfiguration} returns this
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.setExpiryinterval = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional float matchThreshold = 4;
 * @return {number}
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.getMatchthreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.EndpointCacheConfiguration} returns this
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.setMatchthreshold = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional uint64 createdBy = 5;
 * @return {string}
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.getCreatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointCacheConfiguration} returns this
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.setCreatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 updatedBy = 6;
 * @return {string}
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.getUpdatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointCacheConfiguration} returns this
 */
proto.endpoint_api.EndpointCacheConfiguration.prototype.setUpdatedby = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointRetryConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    data: (f = msg.getData()) && proto.endpoint_api.EndpointRetryConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointRetryConfigurationRequest;
  return proto.endpoint_api.CreateEndpointRetryConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 2:
      var value = new proto.endpoint_api.EndpointRetryConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointRetryConfiguration.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointRetryConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.endpoint_api.EndpointRetryConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest} returns this
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional EndpointRetryConfiguration data = 2;
 * @return {?proto.endpoint_api.EndpointRetryConfiguration}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.EndpointRetryConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointRetryConfiguration, 2));
};


/**
 * @param {?proto.endpoint_api.EndpointRetryConfiguration|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest} returns this
*/
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationRequest} returns this
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationRequest.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointRetryConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.endpoint_api.EndpointRetryConfiguration.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointRetryConfigurationResponse;
  return proto.endpoint_api.CreateEndpointRetryConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.EndpointRetryConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointRetryConfiguration.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointRetryConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.EndpointRetryConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional EndpointRetryConfiguration data = 3;
 * @return {?proto.endpoint_api.EndpointRetryConfiguration}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.EndpointRetryConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointRetryConfiguration, 3));
};


/**
 * @param {?proto.endpoint_api.EndpointRetryConfiguration|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} returns this
*/
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} returns this
*/
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointRetryConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointRetryConfigurationResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointCacheConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    data: (f = msg.getData()) && proto.endpoint_api.EndpointCacheConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointCacheConfigurationRequest;
  return proto.endpoint_api.CreateEndpointCacheConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 2:
      var value = new proto.endpoint_api.EndpointCacheConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointCacheConfiguration.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointCacheConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.endpoint_api.EndpointCacheConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest} returns this
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional EndpointCacheConfiguration data = 2;
 * @return {?proto.endpoint_api.EndpointCacheConfiguration}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.EndpointCacheConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointCacheConfiguration, 2));
};


/**
 * @param {?proto.endpoint_api.EndpointCacheConfiguration|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest} returns this
*/
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationRequest} returns this
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationRequest.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointCacheConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.endpoint_api.EndpointCacheConfiguration.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointCacheConfigurationResponse;
  return proto.endpoint_api.CreateEndpointCacheConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.EndpointCacheConfiguration;
      reader.readMessage(value,proto.endpoint_api.EndpointCacheConfiguration.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointCacheConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.EndpointCacheConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional EndpointCacheConfiguration data = 3;
 * @return {?proto.endpoint_api.EndpointCacheConfiguration}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.EndpointCacheConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointCacheConfiguration, 3));
};


/**
 * @param {?proto.endpoint_api.EndpointCacheConfiguration|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} returns this
*/
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} returns this
*/
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.CreateEndpointCacheConfigurationResponse} returns this
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.CreateEndpointCacheConfigurationResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.CreateEndpointTagRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.CreateEndpointTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.CreateEndpointTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.CreateEndpointTagRequest}
 */
proto.endpoint_api.CreateEndpointTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.CreateEndpointTagRequest;
  return proto.endpoint_api.CreateEndpointTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.CreateEndpointTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.CreateEndpointTagRequest}
 */
proto.endpoint_api.CreateEndpointTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.CreateEndpointTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.CreateEndpointTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.CreateEndpointTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.CreateEndpointTagRequest} returns this
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * repeated string tags = 2;
 * @return {!Array<string>}
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.endpoint_api.CreateEndpointTagRequest} returns this
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.endpoint_api.CreateEndpointTagRequest} returns this
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.CreateEndpointTagRequest} returns this
 */
proto.endpoint_api.CreateEndpointTagRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.ForkEndpointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.ForkEndpointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.ForkEndpointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.ForkEndpointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    endpointproviderid: jspb.Message.getFieldWithDefault(msg, 3, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.ForkEndpointRequest}
 */
proto.endpoint_api.ForkEndpointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.ForkEndpointRequest;
  return proto.endpoint_api.ForkEndpointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.ForkEndpointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.ForkEndpointRequest}
 */
proto.endpoint_api.ForkEndpointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointproviderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.ForkEndpointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.ForkEndpointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.ForkEndpointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.ForkEndpointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getEndpointproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.ForkEndpointRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.ForkEndpointRequest} returns this
 */
proto.endpoint_api.ForkEndpointRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 endpointProviderId = 3;
 * @return {string}
 */
proto.endpoint_api.ForkEndpointRequest.prototype.getEndpointproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.ForkEndpointRequest} returns this
 */
proto.endpoint_api.ForkEndpointRequest.prototype.setEndpointproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.UpdateEndpointDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.UpdateEndpointDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.UpdateEndpointDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.UpdateEndpointDetailRequest}
 */
proto.endpoint_api.UpdateEndpointDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.UpdateEndpointDetailRequest;
  return proto.endpoint_api.UpdateEndpointDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.UpdateEndpointDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.UpdateEndpointDetailRequest}
 */
proto.endpoint_api.UpdateEndpointDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.UpdateEndpointDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.UpdateEndpointDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.UpdateEndpointDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.UpdateEndpointDetailRequest} returns this
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.UpdateEndpointDetailRequest} returns this
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.UpdateEndpointDetailRequest} returns this
 */
proto.endpoint_api.UpdateEndpointDetailRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.EndpointLog.repeatedFields_ = [30,32,31,33];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.EndpointLog.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.EndpointLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.EndpointLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    endpointid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    source: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 15, ""),
    projectid: jspb.Message.getFieldWithDefault(msg, 16, "0"),
    organizationid: jspb.Message.getFieldWithDefault(msg, 17, "0"),
    endpointprovidermodelid: jspb.Message.getFieldWithDefault(msg, 19, "0"),
    timetaken: jspb.Message.getFieldWithDefault(msg, 25, "0"),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    metricsList: jspb.Message.toObjectList(msg.getMetricsList(),
    common_pb.Metric.toObject, includeInstance),
    metadataList: jspb.Message.toObjectList(msg.getMetadataList(),
    common_pb.Metadata.toObject, includeInstance),
    argumentsList: jspb.Message.toObjectList(msg.getArgumentsList(),
    common_pb.Argument.toObject, includeInstance),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    common_pb.Metadata.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.EndpointLog}
 */
proto.endpoint_api.EndpointLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.EndpointLog;
  return proto.endpoint_api.EndpointLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.EndpointLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.EndpointLog}
 */
proto.endpoint_api.EndpointLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrganizationid(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointprovidermodelid(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTimetaken(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 30:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addMetrics(value);
      break;
    case 32:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addMetadata(value);
      break;
    case 31:
      var value = new common_pb.Argument;
      reader.readMessage(value,common_pb.Argument.deserializeBinaryFromReader);
      msg.addArguments(value);
      break;
    case 33:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.EndpointLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.EndpointLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.EndpointLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.EndpointLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      16,
      f
    );
  }
  f = message.getOrganizationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      17,
      f
    );
  }
  f = message.getEndpointprovidermodelid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      19,
      f
    );
  }
  f = message.getTimetaken();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      25,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      30,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
  f = message.getMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      32,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getArgumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      31,
      f,
      common_pb.Argument.serializeBinaryToWriter
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      33,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 endpointId = 2;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string source = 3;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 15;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional uint64 projectId = 16;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 16, value);
};


/**
 * optional uint64 organizationId = 17;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 17, value);
};


/**
 * optional uint64 endpointProviderModelId = 19;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getEndpointprovidermodelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setEndpointprovidermodelid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 19, value);
};


/**
 * optional uint64 timeTaken = 25;
 * @return {string}
 */
proto.endpoint_api.EndpointLog.prototype.getTimetaken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.setTimetaken = function(value) {
  return jspb.Message.setProto3StringIntField(this, 25, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.endpoint_api.EndpointLog.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
*/
proto.endpoint_api.EndpointLog.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointLog.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.endpoint_api.EndpointLog.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
*/
proto.endpoint_api.EndpointLog.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.EndpointLog.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * repeated Metric metrics = 30;
 * @return {!Array<!proto.Metric>}
 */
proto.endpoint_api.EndpointLog.prototype.getMetricsList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 30));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
*/
proto.endpoint_api.EndpointLog.prototype.setMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 30, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.endpoint_api.EndpointLog.prototype.addMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 30, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.clearMetricsList = function() {
  return this.setMetricsList([]);
};


/**
 * repeated Metadata metadata = 32;
 * @return {!Array<!proto.Metadata>}
 */
proto.endpoint_api.EndpointLog.prototype.getMetadataList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 32));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
*/
proto.endpoint_api.EndpointLog.prototype.setMetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 32, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.endpoint_api.EndpointLog.prototype.addMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 32, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.clearMetadataList = function() {
  return this.setMetadataList([]);
};


/**
 * repeated Argument arguments = 31;
 * @return {!Array<!proto.Argument>}
 */
proto.endpoint_api.EndpointLog.prototype.getArgumentsList = function() {
  return /** @type{!Array<!proto.Argument>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Argument, 31));
};


/**
 * @param {!Array<!proto.Argument>} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
*/
proto.endpoint_api.EndpointLog.prototype.setArgumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 31, value);
};


/**
 * @param {!proto.Argument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Argument}
 */
proto.endpoint_api.EndpointLog.prototype.addArguments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 31, opt_value, proto.Argument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.clearArgumentsList = function() {
  return this.setArgumentsList([]);
};


/**
 * repeated Metadata options = 33;
 * @return {!Array<!proto.Metadata>}
 */
proto.endpoint_api.EndpointLog.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 33));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.endpoint_api.EndpointLog} returns this
*/
proto.endpoint_api.EndpointLog.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 33, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.endpoint_api.EndpointLog.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 33, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.EndpointLog} returns this
 */
proto.endpoint_api.EndpointLog.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.GetAllEndpointLogRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetAllEndpointLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetAllEndpointLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance),
    endpointid: jspb.Message.getFieldWithDefault(msg, 3, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetAllEndpointLogRequest}
 */
proto.endpoint_api.GetAllEndpointLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetAllEndpointLogRequest;
  return proto.endpoint_api.GetAllEndpointLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetAllEndpointLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetAllEndpointLogRequest}
 */
proto.endpoint_api.GetAllEndpointLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 2:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetAllEndpointLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetAllEndpointLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
};


/**
 * optional Paginate paginate = 1;
 * @return {?proto.Paginate}
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 1));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointLogRequest} returns this
*/
proto.endpoint_api.GetAllEndpointLogRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointLogRequest} returns this
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Criteria criterias = 2;
 * @return {!Array<!proto.Criteria>}
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 2));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.endpoint_api.GetAllEndpointLogRequest} returns this
*/
proto.endpoint_api.GetAllEndpointLogRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.GetAllEndpointLogRequest} returns this
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};


/**
 * optional uint64 endpointId = 3;
 * @return {string}
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.GetAllEndpointLogRequest} returns this
 */
proto.endpoint_api.GetAllEndpointLogRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.endpoint_api.GetAllEndpointLogResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetAllEndpointLogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetAllEndpointLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointLogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.endpoint_api.EndpointLog.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse}
 */
proto.endpoint_api.GetAllEndpointLogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetAllEndpointLogResponse;
  return proto.endpoint_api.GetAllEndpointLogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetAllEndpointLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse}
 */
proto.endpoint_api.GetAllEndpointLogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.EndpointLog;
      reader.readMessage(value,proto.endpoint_api.EndpointLog.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetAllEndpointLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetAllEndpointLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetAllEndpointLogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.endpoint_api.EndpointLog.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated EndpointLog data = 3;
 * @return {!Array<!proto.endpoint_api.EndpointLog>}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.endpoint_api.EndpointLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.endpoint_api.EndpointLog, 3));
};


/**
 * @param {!Array<!proto.endpoint_api.EndpointLog>} value
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
*/
proto.endpoint_api.GetAllEndpointLogResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.endpoint_api.EndpointLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.endpoint_api.EndpointLog}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.endpoint_api.EndpointLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
*/
proto.endpoint_api.GetAllEndpointLogResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
*/
proto.endpoint_api.GetAllEndpointLogResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetAllEndpointLogResponse} returns this
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetAllEndpointLogResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetEndpointLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetEndpointLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetEndpointLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpointid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    id: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetEndpointLogRequest}
 */
proto.endpoint_api.GetEndpointLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetEndpointLogRequest;
  return proto.endpoint_api.GetEndpointLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetEndpointLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetEndpointLogRequest}
 */
proto.endpoint_api.GetEndpointLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setEndpointid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetEndpointLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetEndpointLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetEndpointLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpointid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
};


/**
 * optional uint64 endpointId = 1;
 * @return {string}
 */
proto.endpoint_api.GetEndpointLogRequest.prototype.getEndpointid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.GetEndpointLogRequest} returns this
 */
proto.endpoint_api.GetEndpointLogRequest.prototype.setEndpointid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 id = 2;
 * @return {string}
 */
proto.endpoint_api.GetEndpointLogRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.endpoint_api.GetEndpointLogRequest} returns this
 */
proto.endpoint_api.GetEndpointLogRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.endpoint_api.GetEndpointLogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.endpoint_api.GetEndpointLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointLogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.endpoint_api.EndpointLog.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.endpoint_api.GetEndpointLogResponse}
 */
proto.endpoint_api.GetEndpointLogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.endpoint_api.GetEndpointLogResponse;
  return proto.endpoint_api.GetEndpointLogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.endpoint_api.GetEndpointLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.endpoint_api.GetEndpointLogResponse}
 */
proto.endpoint_api.GetEndpointLogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.endpoint_api.EndpointLog;
      reader.readMessage(value,proto.endpoint_api.EndpointLog.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.endpoint_api.GetEndpointLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.endpoint_api.GetEndpointLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.endpoint_api.GetEndpointLogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.endpoint_api.EndpointLog.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.endpoint_api.GetEndpointLogResponse} returns this
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.endpoint_api.GetEndpointLogResponse} returns this
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional EndpointLog data = 3;
 * @return {?proto.endpoint_api.EndpointLog}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.getData = function() {
  return /** @type{?proto.endpoint_api.EndpointLog} */ (
    jspb.Message.getWrapperField(this, proto.endpoint_api.EndpointLog, 3));
};


/**
 * @param {?proto.endpoint_api.EndpointLog|undefined} value
 * @return {!proto.endpoint_api.GetEndpointLogResponse} returns this
*/
proto.endpoint_api.GetEndpointLogResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetEndpointLogResponse} returns this
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.endpoint_api.GetEndpointLogResponse} returns this
*/
proto.endpoint_api.GetEndpointLogResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.endpoint_api.GetEndpointLogResponse} returns this
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.endpoint_api.GetEndpointLogResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.endpoint_api);
